import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Choose Action:", -1)
const _hoisted_3 = { class: "text-gray-400 mt-2 flex justify-around" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Sign Metadata", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Create Metadata PDA", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Create Master PDA", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" (!) Only use this if you know what you're doing. If all you want is to mint a new NFT, go to mint tab, all PDAs will be created for you. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" (!) You will need to have created a Metadata PDA first. ")
const _hoisted_9 = { class: "nes-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "editionMint" }, "NFT Mint:")
], -1)
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "nes-field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "editionMint2" }, "New SPL Token Mint:", -1)
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "nes-field mt-5" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "newMetadataData" }, "Metadata as JSON:", -1)
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "nes-field mt-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "newUpdateAuthority" }, "Update Authority (optional):")
], -1)
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "nes-field" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "editionMint3" }, "New SPL Token Mint:", -1)
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = { class: "nes-field mt-5" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "newUpdateAuthority2" }, "Update Authority (optional):")
], -1)
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = { class: "nes-field mt-5" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "maxSupply" }, "Max Supply (leave blank for uncapped):")
], -1)
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "Done! 🎉", -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Waiting for transaction to confirm... (might take a few sec)")
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotifyWarning = _resolveComponent("NotifyWarning")!
  const _component_QuestionMark = _resolveComponent("QuestionMark")!
  const _component_StdNotifications = _resolveComponent("StdNotifications")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_ExplorerLink = _resolveComponent("ExplorerLink")!
  const _component_NotifySuccess = _resolveComponent("NotifySuccess")!
  const _component_ContentTooltipMetadata = _resolveComponent("ContentTooltipMetadata")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!
  const _component_ContentTooltipNftToken = _resolveComponent("ContentTooltipNftToken")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            class: "nes-radio",
            value: "signMetadata",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chosenAction) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.chosenAction]
          ]),
          _hoisted_4
        ]),
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            class: "nes-radio",
            value: "createMetadata",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chosenAction) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.chosenAction]
          ]),
          _hoisted_5
        ]),
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            class: "nes-radio",
            value: "createMaster",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chosenAction) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.chosenAction]
          ]),
          _hoisted_6
        ])
      ])
    ]),
    (_ctx.chosenAction === 'createMetadata' || _ctx.chosenAction === 'createMaster')
      ? (_openBlock(), _createBlock(_component_NotifyWarning, {
          key: 0,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.chosenAction === 'createMaster')
      ? (_openBlock(), _createBlock(_component_NotifyWarning, {
          key: 1,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.chosenAction === 'signMetadata')
      ? (_openBlock(), _createElementBlock("form", {
          key: 2,
          class: "mt-10",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signMetadata && _ctx.signMetadata(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "editionMint",
              class: "nes-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editionMint) = $event)),
              placeholder: _ctx.DEFAULTS.MASTER_MINT
            }, null, 8, _hoisted_11), [
              [_vModelText, _ctx.editionMint]
            ])
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(["nes-btn is-primary mt-5", { 'is-disabled': _ctx.isLoading || !_ctx.isConnected }]),
            disabled: _ctx.isLoading || !_ctx.isConnected,
            type: "submit"
          }, " Sign Metadata ", 10, _hoisted_12)
        ], 32))
      : (_ctx.chosenAction === 'createMetadata')
        ? (_openBlock(), _createElementBlock("form", {
            key: 3,
            class: "mt-5",
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createMetadata && _ctx.createMetadata(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _hoisted_14,
                _createVNode(_component_QuestionMark, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModal('nftToken')))
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "editionMint2",
                class: "nes-input",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editionMint) = $event)),
                placeholder: _ctx.DEFAULTS.MASTER_MINT
              }, null, 8, _hoisted_15), [
                [_vModelText, _ctx.editionMint]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _hoisted_17,
                _createVNode(_component_QuestionMark, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModal('tooltipMetadata')))
                })
              ]),
              _withDirectives(_createElementVNode("textarea", {
                rows: "5",
                id: "newMetadataData",
                class: "nes-input",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newMetadataData) = $event)),
                placeholder: _ctx.DEFAULTS.METADATA
              }, null, 8, _hoisted_18), [
                [_vModelText, _ctx.newMetadataData]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "newUpdateAuthority",
                class: "nes-input",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newUpdateAuthority) = $event)),
                placeholder: _ctx.DEFAULTS.UPDATE_AUTHORITY
              }, null, 8, _hoisted_21), [
                [_vModelText, _ctx.newUpdateAuthority]
              ])
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["nes-btn is-primary mt-5", { 'is-disabled': _ctx.isLoading || !_ctx.isConnected }]),
              disabled: _ctx.isLoading || !_ctx.isConnected,
              type: "submit"
            }, " Create Metadata PDA ", 10, _hoisted_22)
          ], 32))
        : (_ctx.chosenAction === 'createMaster')
          ? (_openBlock(), _createElementBlock("form", {
              key: 4,
              class: "mt-5",
              onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createMaster && _ctx.createMaster(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", null, [
                  _hoisted_24,
                  _createVNode(_component_QuestionMark, {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showModal('nftToken')))
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "editionMint3",
                  class: "nes-input",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editionMint) = $event)),
                  placeholder: _ctx.DEFAULTS.MASTER_MINT
                }, null, 8, _hoisted_25), [
                  [_vModelText, _ctx.editionMint]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "newUpdateAuthority2",
                  class: "nes-input",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newUpdateAuthority) = $event)),
                  placeholder: _ctx.DEFAULTS.UPDATE_AUTHORITY
                }, null, 8, _hoisted_28), [
                  [_vModelText, _ctx.newUpdateAuthority]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "maxSupply",
                  class: "nes-input",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.maxSupply) = $event)),
                  placeholder: _ctx.DEFAULTS.MAX_SUPPLY
                }, null, 8, _hoisted_31), [
                  [_vModelText, _ctx.maxSupply]
                ])
              ]),
              _createElementVNode("button", {
                class: _normalizeClass(["nes-btn is-primary mt-5", { 'is-disabled': _ctx.isLoading || !_ctx.isConnected }]),
                disabled: _ctx.isLoading || !_ctx.isConnected,
                type: "submit"
              }, " Create Master PDA ", 10, _hoisted_32)
            ], 32))
          : _createCommentVNode("", true),
    _createVNode(_component_StdNotifications, {
      "is-connected": _ctx.isConnected,
      "is-loading": _ctx.isLoading,
      error: _ctx.error
    }, null, 8, ["is-connected", "is-loading", "error"]),
    (_ctx.txId)
      ? (_openBlock(), _createBlock(_component_NotifySuccess, {
          key: 5,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _hoisted_33,
            (!_ctx.confirmed)
              ? (_openBlock(), _createBlock(_component_LoadingIcon, {
                  key: 0,
                  align: "left",
                  class: "mt-5"
                }, {
                  default: _withCtx(() => [
                    _hoisted_34
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  (_ctx.pda)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Newly created PDA: " + _toDisplayString(_ctx.pda), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ExplorerLink, { "tx-id": _ctx.txId }, null, 8, ["tx-id"])
                ]))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isModalVisible('tooltipMetadata'))
      ? (_openBlock(), _createBlock(_component_ModalWindow, {
          key: 6,
          title: "How to format Metadata?",
          onHideModal: _cache[16] || (_cache[16] = ($event: any) => (_ctx.hideModal('tooltipMetadata')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ContentTooltipMetadata)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isModalVisible('nftToken'))
      ? (_openBlock(), _createBlock(_component_ModalWindow, {
          key: 7,
          title: "What token is this?",
          onHideModal: _cache[17] || (_cache[17] = ($event: any) => (_ctx.hideModal('nftToken')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ContentTooltipNftToken)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}